const templateHelpers = {

  loadAttributes(product, localAttributes) {
    if (product.attributes) {
      product.attributes.forEach(a => {
        if (localAttributes[a.name.toLowerCase()]) {
          localAttributes[a.name.toLowerCase()].retail_price = a.pivot.retail_price;
          localAttributes[a.name.toLowerCase()].net_rate = a.pivot.net_rate;
          localAttributes[a.name.toLowerCase()].sub_title = a.pivot.sub_title;
        }
      });
    }
  },

  loadCustomFields(product, localCustomFields) {
    if (product.customFields) {
      product.customFields.forEach(c => {
        if (localCustomFields[c.field_code]) {
          localCustomFields[c.field_code].value = c.value;
        }
      });
    }
  },

};

export { templateHelpers };
